<template>
  <div class="col-auto px-0 hidden xl:flex self-stretch">
    <div class="navbar__search flex flex-col justify-center flex-grow-1">
      <VDropdown
        theme="search"
        :shown="showSearch"
        @apply-show="loadCrossSell"
        @apply-hide="toggleShowSearch"
      >
        <Search
          type="navbar"
          :items="products"
          @value-changed="searchValueChanged"
          @search-changed="searchChanged"
          @enter-pressed="goToSearchView"
        />
        <template #popper>
          <div class="row m-0">
            <div class="col-3 bg-primary-200 px-3 py-2">
              <h3 class="text-lg text-primary">
                {{ t('categories') }}
              </h3>
              <CategorySearchResults :search-categories="categories" />
            </div>
            <ProductsSearchResults
              v-if="products.length > 0 || mainProduct"
              :main-product="mainProduct"
              :products="products"
              :search-text="searchText"
            />
            <div
              v-if="searchText && products.length === 0 && !mainProduct"
              class="col-9 p-4"
            >
              <span class="text-primary opacity-20 mt-5 pb-4 block text-center">
                <i class="mi-search-err icon-180" />
              </span>
              <p class="m-0 py-1 px-1 relative text-center">
                {{ t('we_do_not_know_this_beak') }}
              </p>
            </div>
            <ProductsSearchResults
              v-if="products.length === 0 && !searchText && crossSell"
              :main-product="crossSell[0]"
              :products="crossSell.slice(1)"
              :search-text="searchText"
              :show-all-results="false"
            />
          </div>
        </template>
      </VDropdown>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import RetailApiV2 from '@/api/retailApi/RetailApiV2'
import Search from '@/components/general/BaseSearch.vue'
import CategorySearchResults from '@/components/menus/navbar/TheNavbarCategorySearchResults.vue'
import ProductsSearchResults from '@/components/menus/navbar/TheNavbarProductsSearchResults.vue'
import { useProductStore } from '@/stores/ProductStore'

const { t } = useI18n()
const router = useRouter()
const mainProduct = ref()
const products = ref([])
const categories = ref([])
const searchText = ref()
const showSearch = ref(false)

const toggleShowSearch = (value) => {
  showSearch.value = value
}

document.addEventListener('click', (e) => {
  if (document.querySelector('.v-popper--theme-search') && !e.target.closest('.v-popper--theme-search')) {
    toggleShowSearch(false)
  }
})

const productStore = useProductStore()

const crossSell = ref()

const loadCrossSell = async () => {
  const selectedProducts = await productStore.loadCrossSell('quantity=7&kind=search_cross_sell')
  if (selectedProducts && selectedProducts.length > 0) {
    crossSell.value = selectedProducts
  } else {
    const mostPopularProducts = await productStore.loadCrossSell('quantity=7&kind=homepage_favorite_cross_sell')
    crossSell.value = mostPopularProducts
  }
  toggleShowSearch(true)
}

const searchValueChanged = (value) => {
  searchText.value = value
}
const searchChanged = async (value) => {
  searchText.value = value
  if (value.length > 0) {
    const { data } = await RetailApiV2.get(`search?q=${value}&limit=7&variant=modest`)
    mainProduct.value = data.products.shift()
    products.value = data.products
    categories.value = data.categories
  } else {
    products.value = []
    categories.value = []
    mainProduct.value = null
  }
}
const goToSearchView = () => {
  const url = router.resolve({ name: 'searchPath', params: { search: searchText.value } })
  window.location.href = url.href
}
</script>

<i18n>
  {
    "cs": {
    "categories": "Kategorie",
    "we_do_not_know_this_beak": "Tohle zobání neznáme.",
    "write_what_you_are_looking": "Napište, jaké dobroty hledáte"
},
    "sk": {
    "categories": "Kategórie",
    "we_do_not_know_this_beak": "Toto zobkanie nepoznáme.",
    "write_what_you_are_looking": "Napíšte, aké dobroty hľadáte"
},
    "pl": {
    "categories": "Kategorie",
    "we_do_not_know_this_beak": "Tych przekąsek nie znamy :-(",
    "write_what_you_are_looking": "Napisz, jakich przekąsek szukasz"
},
    "hu": {
    "categories": "Kategóriák",
    "we_do_not_know_this_beak": "Ezt nem ismerjük :-(",
    "write_what_you_are_looking": "Írd le, milyen finomságokat keresel"
},
    "de": {
    "categories": "Kategorie",
    "we_do_not_know_this_beak": "Diesen Snack kennen wir nicht :-(",
    "write_what_you_are_looking": "Schreib uns, welche Leckereien du suchst"
},
    "at": {
    "categories": "Kategorie",
    "we_do_not_know_this_beak": "Diesen Snack kennen wir nicht :-(",
    "write_what_you_are_looking": "Schreib uns, welche Leckereien du suchst"
},
    "ro": {
    "categories": "Categorii",
    "we_do_not_know_this_beak": "Nu cunoaștem această bunătate :-(",
    "write_what_you_are_looking": "Scrieți ce bunătăți căutați"
},
    "fr": {
    "categories": "Catégories",
    "we_do_not_know_this_beak": "Nous ne connaissons pas ce produit.",
    "write_what_you_are_looking": "Dites-nous quelle gourmandise vous cherchez"
},
    "it": {
    "categories": "Categoria",
    "we_do_not_know_this_beak": "Non conosciamo questo spuntino.",
    "write_what_you_are_looking": "Scrivi quali prelibatezze stai cercando"
}
  }
</i18n>
